import React, { ReactElement, useEffect, useState } from 'react';
import { Button, Col, Row, Space } from 'antd';
import { NOT_ELIGIBLE_INSURER_ERR, POLICY_NOT_ELIGIBLE } from '../../../../../../shared/constants/commonConstants';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../../../../store';
import { AdmissionForm, NewAdmissionState } from '../../../../../../store/models/newAdmissionModel';
import { customGTMEvent, findKeyValuePair, updateAdmissionFormValue } from '../../../service/crmUtils';
import * as actions from '../../../../../../store/actions/newAdmissionAction';
import { cloneDeep, isEmpty } from 'lodash';
import { BENEF_WARNING_MESSAGE, DEFAULT_ADMISSION_FORM_VALUE, MEMBER_SELECTION_CONFIRMATION, OTHER_ID, SKIPPED_BENEF_SEARCH } from '../../../../../../shared/constants/crmConstants';
import { centeredNotification } from '../../../../../../utils/utility';
import moment from 'moment';
import { getDateWithMonthText } from '../../../../../../utils/dateTimeUtils';
import AutoPopulateProcedures from '../AutoPopulateProceduresModal/AutoPopulateProcedures';
import { useMigrateClaimDetail } from '../../../../../../shared/hooks/useMigrateClaimDetail';
import { ReactComponent as Info_Icon } from '../../../../../../assets/images/svg/information_Icon.svg';
import { ReactComponent as Warning_Icon } from '../../../../../../assets/images/svg/warning_icon.svg';
import { ReactComponent as Exception_Icon } from '../../../../../../assets/images/svg/Exception.svg';
import BeneficiaryCardRedesign from '../cards/BeneficiaryCard/BeneficiaryCardRedesign';
import { setSelectedPolicyDetail } from '../../../../../../store/actions/nhcxAction';
import { setSelectedTab } from '../../../../../../store/actions/newAdmissionAction';
import { endOfDay, isAfter } from 'date-fns';
import { setAutomatedNewAdmission } from '../../../../../../store/actions/hospitalAction';
import { BeneficiaryDetail } from '../../../../../../shared/interfaces/newAdmissionInterface';

const BeneficiarySearchCards = ({ detailNav, prefillOldData = true,
  completeStep, resetStep, stepCount, totalSteps, claimForm }: any): any => {
  const dispatch = useDispatch();
  const { showBeneficiaryCard, beneficiaryList, selectedBeneficiaryDetail, selectedTab, isDraftSelected,
    isBeneficiaryPopUpRequired, selectedMemberCardIndex, admissionFormVal, isShowAdmissionForm, allowNextStage, starDisabledBenefMessage,
  }: any = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { selectedPatientDetail, isAutomatedNewAdmission } = useSelector((state: RootState): any => state?.hospital);
  const { payerList: { payer: { uniqueIdentifier, id: payerId, isBenefSearchEnabled } }, payerLookUp } =
    useSelector((state: RootState): RootState => state);
  const [isConfirmModalVisible, setIsConfirmModalVisible] = useState(false);
  const [setBenefValue, setIsBenefValue] = useState<string | { nameMatchMessage: string, percentageNameMatch: string,
    isLimitedCashless: boolean }>('');
  const [tempBeneficiary, setTempBeneficiary] = useState<any>(null);
  const [isOldDataLoading, setIsOldDataLoading] = useState<boolean>(false);
  const [isAutoPopulateModalVisible, setIsAutoPopulateModalVisible] = useState(false);
  const [tempClaimDetail, setTempClaimDetail] = useState(null);
  const [oldClaimDetail, setOldClaimDtail] = useState<any>(null);
  useMigrateClaimDetail(isOldDataLoading, false, oldClaimDetail);
  const [icon, setIcon] = useState<any>(null);

  useEffect((): any => {
    if (tempBeneficiary) {
      if (prefillOldData) {
        setIsOldDataLoading(true);
        tempBeneficiary.memberGenderSelect = tempBeneficiary?.memberGenderSex;
        dispatch(actions.getOldClaimDetails(tempBeneficiary, onOldClaimSuccess));
      } else {
        setIsOldDataLoading(false);
        onSkip();
      }
    }
  }, [tempBeneficiary]);

  useEffect((): any => {
    const handleOutsideClick = (e: any): any => {
      if (!document.querySelector('.NA-benefPopUpModal')?.contains(e.target)) {
        setIsConfirmModalVisible(false);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);

    return (): any => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  useEffect((): any => {
    if (typeof setBenefValue === 'object') {
      (setBenefValue?.percentageNameMatch <= '90' && setBenefValue?.percentageNameMatch >= '60') ? setIcon('Warning') :
        (setBenefValue?.percentageNameMatch < '60') ? setIcon('Error') : setIcon('');
    }
  }, [setBenefValue]);

  const onOldClaimSuccess = (claimDetail?: any): any => {
    setIsOldDataLoading(false);
    if (claimDetail) {
      setIsAutoPopulateModalVisible(true);
      setTempClaimDetail(claimDetail);
    } else {
      setOldClaimDtail(null);
      setTempClaimDetail(null);
      onSkip();
    }
  };

  const onSkip = (): any => {
    setOldClaimDtail(null);
    setTempClaimDetail(null);
    const { memberName = '', roomType } = tempBeneficiary;
    const formVal: any = updateAdmissionFormValue(
      tempBeneficiary, admissionFormVal as AdmissionForm, payerLookUp[uniqueIdentifier]?.insurerName, selectedPatientDetail,
    );

    const selectedRoom = findKeyValuePair(payerLookUp[uniqueIdentifier]?.roomType, 'payerMasterValue', roomType);
    if (selectedRoom) {
      claimForm.setFieldsValue({
        ...formVal[detailNav[selectedTab >= 0 ? selectedTab : 0].formKey],
        hospitalRoomType: OTHER_ID, payerRoomType: selectedRoom?.value,
        inPatientNumber: selectedPatientDetail?.patientDetails?.inpatientNumber || selectedPatientDetail?.lastIPID,
      });
      dispatch(actions.disableRoomType(true));
      dispatch(actions.toggleOtherRoomType(true));
    }
    claimForm.setFieldsValue({
      inPatientNumber: selectedPatientDetail?.patientDetails?.inpatientNumber || selectedPatientDetail?.lastIPID,
    });
    dispatch(actions.setAdmissionForm(formVal));
    dispatch(actions.setMemberName(memberName));
    setIsAutoPopulateModalVisible(false);
    openForm();
  };

  const onProceed = (): any => {
    setOldClaimDtail(tempClaimDetail);
    dispatch(actions.setAutoPopulateDayCareProcedure(true));
    setIsAutoPopulateModalVisible(false);
    openForm();
  };
  const openForm = (): any => {
    const { policyEndDate } = tempBeneficiary || {};
    if (policyEndDate && isAfter(new Date(), endOfDay(new Date(policyEndDate)))) {
      centeredNotification(`Policy expiry date is ${getDateWithMonthText(policyEndDate)}.`, 'info');
    }
    if (typeof setBenefValue === 'object' && setBenefValue?.isLimitedCashless) {
      dispatch(actions.setIsShowAdmissionForm(false));
      centeredNotification(POLICY_NOT_ELIGIBLE, 'error');
    } else {
      dispatch(actions.setSelectedBeneficiary(tempBeneficiary));
      isAutomatedNewAdmission && dispatch(setAutomatedNewAdmission(false));
      dispatch(actions.setPercentageNameMatch(tempBeneficiary?.percentageNameMatch));
      dispatch(actions.setGovtSchemeUrn(tempBeneficiary?.urn));
      dispatch(actions.setIsShowAdmissionForm(true));
      dispatch(actions.updateAdmissionStartTime(moment().utcOffset('+05:30').format()));
      setIsAutoPopulateModalVisible(false);
    }
  };

  const handleCardSelection = (beneficiary: BeneficiaryDetail, index: number): void => {
    if (!isConfirmModalVisible && beneficiary !== selectedBeneficiaryDetail && allowNextStage) {
      proceedCheck(beneficiary, index);
    }
  };

  useEffect((): void => {
    if (isAutomatedNewAdmission && !isEmpty(beneficiaryList) && isBenefSearchEnabled && payerId !== 0) {
      beneficiaryList.some((benef: any, index: number): boolean => {
        if (benef.percentageNameMatch === 100) {
          handleCardSelection(benef, index);
          return true;
        }
        return false;
      }) || dispatch(setAutomatedNewAdmission(false));
    }
  }, [beneficiaryList]);

  const proceedCheck = (selectedBenef: any, index: any): any => {
    customGTMEvent({
      event: 'MEMBER_CARD_SELECTED',
      membersFound: beneficiaryList?.length ?? 'N/A',
    });
    selectedBenef.index = index;
    setIsBenefValue(selectedBenef);
    completeStep('memberSearch');
    if (isEmpty(setSelectedPolicyDetail)) {
      completeStep('memberCard');
    }
    (beneficiaryList.length > 1 && (selectedBenef !== selectedBeneficiaryDetail)) ?
      setIsConfirmModalVisible(true) : checkIsMemberAllowedAsPerInsurer(selectedBenef);
  };

  const checkIsMemberAllowedAsPerInsurer = (selectedBenef: any): any => {
    if (beneficiaryList?.length > 1 && selectedBenef !== selectedBeneficiaryDetail) {
      dispatch(actions.setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    }
    const submissionAllowed = findKeyValuePair(
      (payerLookUp[uniqueIdentifier]?.providerSpecificInsurers || []), 'value', selectedBenef?.insuranceCompanyId, true);
    if (payerLookUp[uniqueIdentifier]?.isHospSpecificInsurerPayerResponse && selectedBenef?.insuranceCompanyId && !submissionAllowed) {
      centeredNotification(NOT_ELIGIBLE_INSURER_ERR(selectedBenef?.insuranceCompanyName));
      return;
    }
    setTempBeneficiary(selectedBenef);
    dispatch(actions.setSelectedBenfStatus(selectedBenef?.status));
    dispatch(actions.setSelectedCardIndex(selectedBenef?.index));
  };

  const handleModalProceedClick = (): any => {
    setIsConfirmModalVisible(false);
    isAutomatedNewAdmission && dispatch(setAutomatedNewAdmission(false));
    dispatch(setSelectedTab(0));
    checkIsMemberAllowedAsPerInsurer(setBenefValue);
    completeStep('memberSearch');
    if (isEmpty(setSelectedPolicyDetail)) {
      completeStep('memberCard');
    }
  };

  useEffect((): void => {
    if (isConfirmModalVisible && isAutomatedNewAdmission) {
      handleModalProceedClick();
    }

  }, [isConfirmModalVisible]);

  return (
    <>
      {isShowAdmissionForm && (
        <>
          {!isDraftSelected && payerId !== 0 && isBenefSearchEnabled && beneficiaryList?.length === 0 && (
            <>
              <div className="step-header-container">
                <span className="step-header-count">
                  Step&nbsp;<span className="step-count-number">{stepCount} / {totalSteps}</span>
                </span>
                <span className="step-header-text">Select Member Card</span>
              </div>
              <div className="skipped-step">
                <span className="skipped-message">
                  {SKIPPED_BENEF_SEARCH}
                </span>
              </div>
            </>
          )}
        </>
      )}
      {(showBeneficiaryCard && !isEmpty(beneficiaryList)) &&
        <Row gutter={16} data-testid="beneficiary-cards" className="beneficiaryCards">
          {showBeneficiaryCard &&
            beneficiaryList.map((beneficiary: any, index: number): ReactElement => {
              return <>
                <Col xs={24} sm={24} md={12} lg={12} xl={12} xxl={8} key={index} className="benef-card-col"
                  onClick={(): void => handleCardSelection(beneficiary, index)}>
                  <BeneficiaryCardRedesign
                    isSelected={beneficiary === setBenefValue}
                    loading={isOldDataLoading}
                    beneficiary={beneficiary}
                    index={index}
                    isBeneficiaryPopUpRequired={isBeneficiaryPopUpRequired}
                    isConfirmed={index === selectedMemberCardIndex}
                    disabled={!allowNextStage}
                    starDisabledBenefMessage={starDisabledBenefMessage}
                  />
                </Col>
              </>;
            })
          }
          {isConfirmModalVisible && (
            <div className="NA-benefPopUpModal">
              {isBeneficiaryPopUpRequired ? (
                <div className="modal_icon">
                  {icon === 'Warning' ? (
                    <Warning_Icon />
                  ) : icon === 'Error' ? (
                    <Row style={{ justifyContent: 'center' }}>
                      <Col className="benef-popup-icon">
                        <Exception_Icon />
                      </Col>
                      <Col style={{ marginTop: '5px' }}>Low Match Alert:</Col>
                    </Row>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <></>
              )}
              {isBeneficiaryPopUpRequired ? (
                <div
                  className="benef-pop-message"
                  dangerouslySetInnerHTML={{
                    __html:
                      typeof setBenefValue === 'object'
                        ? setBenefValue.nameMatchMessage
                        : `<div>${MEMBER_SELECTION_CONFIRMATION}</div>`,
                  }}
                />
              ) : (
                <div>
                  {MEMBER_SELECTION_CONFIRMATION}
                </div>
              )}
              <div className="modalButtons">
                <Space direction="horizontal" size="large">
                  <Button
                    key="close"
                    type="default"
                    className="beneficiary-confirm-cancel"
                    onClick={(): any => {
                      if (isEmpty(selectedBeneficiaryDetail)) {
                        resetStep('memberSearch');
                        resetStep('memberCard');
                      }
                      setIsConfirmModalVisible(false);
                      isAutomatedNewAdmission && dispatch(setAutomatedNewAdmission(false));
                    }}
                  >
                    Back
                  </Button>
                  <Button
                    key="submit"
                    type="primary"
                    className="beneficiary-confirm-proceed"
                    onClick={handleModalProceedClick}
                  >
                    Proceed
                  </Button>
                </Space>
              </div>
              <div className="msgDiv">
                <Info_Icon />
                <span className="messageDiv">{BENEF_WARNING_MESSAGE}</span>
              </div>
            </div>
          )}
          {
            !isConfirmModalVisible &&
            <AutoPopulateProcedures
              claimDetail={tempClaimDetail}
              visible={isAutoPopulateModalVisible}
              handleProceed={onProceed}
              handleSkip={onSkip}
            />
          }
        </Row>}
    </>
  );
};

export default BeneficiarySearchCards;
